module.exports = __webpack_public_path__ + "img/about-shape-6.51df7c32.png";